import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=7b85979c&scoped=true&"
import script from "./PaymentForm.vue?vue&type=script&lang=js&"
export * from "./PaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=7b85979c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85979c",
  null
  
)

export default component.exports